export default () => ({
   instanceRecid: -1,
   templateRecid: -1,
   channelRecid: -1,

   isLoadingInstance: false,
   instanceJson: {},
   allZones: [],
   instanceTitle: '',
   instanceStatus: 1,
   thumbnail: '',
   duration: 0,
   channels: [],

   currScene: "scene1",

   editsMade: false,
   activeZoneType: -1,
   activeZoneId: -1,
   activeZone: null,
   currActiveAssetRecid: -1,
   zoneToAssetsDict: {}, //keeping track of our zone to asset relationships
   isGlobal: false,
   hiddenZones: [],
   moveImage: 0,  
   mpOpen: false,
   overlay: false,
   displayColorPicker: false,
   moveImageZoneId: -1,
   preview: false,
   saveAsState: false,
   unsavedNavigationState: false,
   mediaPickerOpen: false,

   userRole: 0,

   //error states
   duplicateTitleErrorState: false,
   attemptedStatusSave: 0, //storing the status the user was trying to save as when they encountered the error

   isSaving: false,
   isSavingAs: false,

   unlockInstanceModal: false,
   editingInstanceUser: '',
   attemptedOpenInstanceRecid: -1,
   attemptedOpenChannelRecid: -1,

   errorMessage: null,

   locked: false,
   editingUser: '',


   //Errors
   uniqueTitleError: false

});